// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Q2BC","selected":"Chip_selected__1QLjA"};